import { Pipe, PipeTransform } from '@angular/core';
import { DataEnteredBy } from '../enums/schema-status';
import { TranslocoService } from '@jsverse/transloco';
import { map, Observable } from 'rxjs';

@Pipe({
    name: 'schemaDataEnterer',
    standalone: true
})
export class SchemaDataEntererPipe implements PipeTransform {
    constructor(private translocoService: TranslocoService) { }

    transform(dataEnteredBy: string): Observable<string> {
        return this.translocoService.selectTranslateObject<Record<string, string>>("schema.dataenteredby").pipe(
            map(x => {

                switch (true) {
                    case (dataEnteredBy == DataEnteredBy.Doctor):
                        return x["doctor"];
                    case (dataEnteredBy == DataEnteredBy.Assisted):
                        return x["assisted"];
                    default:
                        return x["patient"];
                }
            })
        );
    }
}